import { Injectable, SecurityContext } from '@angular/core';
import { DirectUploadRequest, FileUploader, UploadRequest } from './file.uploader';
import { HttpClient, HttpContext, HttpEventType } from '@angular/common/http';
import { MTMCustomFile } from './mtm-custom-file';
import { environment } from '../../../../environments/environment';
import { TransferStatus } from './transfer-status';
import { listenerFileUploaded, listenerUploadStatusChanged } from './listeners';
import { EMPTY, Observable } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
import { IS_UNCANCELABLE_REQUEST } from '../../models';
import { UrlSanitizer } from '../api.service';
import { HttpHelperService } from '../http-helper.service';

@Injectable({
  providedIn: 'root',
})
export class DirectFileUploader implements FileUploader {
  constructor(
    private readonly http: HttpClient,
    private readonly httpHelperService: HttpHelperService,
    private readonly sanitizer: DomSanitizer
  ) {}

  uploadFiles(request: UploadRequest) {
    const directRequest = request as DirectUploadRequest;
    if (!directRequest) {
      return;
    }
    request.files.forEach((file) => {
      file.sessionUrl = environment.api.baseUrl + '/' + directRequest.uploadUrl;
      this.doDirectUpload(file);
    });
  }

  cancelUpload(file: MTMCustomFile): Observable<any> {
    return EMPTY;
  }

  //at the moment direct upload only uses multipart FormData
  doDirectUpload(file: MTMCustomFile) {
    const data = new FormData();
    data.append('file', file.file, file.fileName || 'mtm-file');

    file.uploadStatusCode = TransferStatus.SENDING;
    const headers: Record<string, string> = {};
    this.httpHelperService
      .getHttpHeaders()
      .keys()
      .forEach((name) => {
        const value = this.httpHelperService.getHttpHeaders().get(name);
        if (value && name !== 'Content-Type') {
          headers[name] = value;
        }
      });

    //let browser set boundary automatically in multipart/form-data
    if ('Content-Type' in headers) {
      delete headers['Content-Type'];
    }

    //warning: don't encode the url
    const safeurl = UrlSanitizer.sanitizeUrl(file.sessionUrl);

    this.http
      .post(safeurl, data, {
        headers: headers,
        reportProgress: true,
        observe: 'events',
        context: new HttpContext().set(IS_UNCANCELABLE_REQUEST, true),
      })
      .subscribe({
        next: (response: any) => {
          switch (response.type) {
            case HttpEventType.UploadProgress:
              file.progress = Math.round((100 * response.loaded) / response.total);
              break;
            case HttpEventType.Response:
              file.progress = 100;
              file.uploadStatusCode = TransferStatus.COMPLETED;
              file.setDbFileObject(response.body);
              listenerUploadStatusChanged.next(file);
              listenerFileUploaded.next(file);
              break;
          }
        },
        error: (error) => {
          file.uploadStatusCode = TransferStatus.ERROR;
          listenerUploadStatusChanged.next(file);
        },
      });
  }
}
